import * as React from 'react';

import ChakraButton from '~/common/components/Buttons/Button/index';

type ButtonProps = React.ComponentPropsWithRef<typeof ChakraButton> & {
  isPrimary?: boolean;
  isDefaultTextColor?: boolean;
  isLoading?: boolean;
  isDisabled?: boolean;
  dataTestid?: string;
  dataTracking?: string;
};

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      isPrimary = true,
      isLoading = false,
      isDisabled = false,
      dataTestid = '',
      dataTracking = 'N/A',
      children,
      ...props
    },
    ref,
  ) => {
    const buttonProps = isPrimary
      ? {
          color: 'white',
          backgroundColor: 'blue.600',
          _hover: { backgroundColor: 'blue.500' },
          'data-testid': dataTestid || 'primary-button',
          ...props,
        }
      : {
          colorScheme: 'blue',
          variant: 'outline',
          'data-testid': dataTestid || 'secondary-button',
          ...props,
        };
    buttonProps['data-tracking'] = dataTracking;

    return (
      <ChakraButton
        ref={ref}
        isLoading={isLoading}
        isDisabled={isDisabled}
        {...buttonProps}
      >
        {children}
      </ChakraButton>
    );
  },
);

export default Button;
